export const CRUT = {
    wizard: {
        autobillDetails: {
            bsbNumber: 'Sort Code',
        }
    }
}